import { 
  Workflow, Zap, Clock, CheckCircle, Users, AlertTriangle, 
  XCircle, RefreshCw, Target, MessageCircle, Mail, Bell, Tag 
} from 'lucide-react';

export const TRIGGER_TYPES = [
  { value: 'new_quote', label: 'New Quote Received', icon: Zap, color: 'text-blue-500' },
  { value: 'quote_no_response', label: 'Quote - No Response', icon: Clock, color: 'text-orange-500' },
  { value: 'booking_confirmed', label: 'Booking Confirmed', icon: CheckCircle, color: 'text-green-500' },
  { value: 'driver_assigned', label: 'Driver Assigned', icon: Users, color: 'text-purple-500' },
  { value: 'in_transit', label: 'In Transit', icon: Workflow, color: 'text-cyan-500' },
  { value: 'delivery_complete', label: 'Delivery Complete', icon: CheckCircle, color: 'text-green-600' },
  { value: 'enquiry_not_closed', label: 'Enquiry Not Closed (7+ days)', icon: AlertTriangle, color: 'text-yellow-500' },
  { value: 'customer_inactive', label: 'Customer Inactive (60+ days)', icon: XCircle, color: 'text-red-500' },
  { value: 'lifecycle_change', label: 'Lifecycle Stage Change', icon: RefreshCw, color: 'text-indigo-500' },
  { value: 'revenue_milestone', label: 'Revenue Milestone Reached', icon: Target, color: 'text-emerald-500' },
];

export const ACTION_TYPES = [
  { value: 'send_whatsapp', label: 'Send WhatsApp Message', icon: MessageCircle },
  { value: 'send_email', label: 'Send Email', icon: Mail },
  { value: 'create_follow_up', label: 'Create Follow-Up Task', icon: Bell },
  { value: 'assign_tag', label: 'Assign Customer Tag', icon: Tag },
  { value: 'update_lifecycle', label: 'Update Lifecycle Stage', icon: RefreshCw },
];
